import { Typography, useMediaQuery, useTheme } from '@material-ui/core';
import useStyles from './styles';
import React, { FC } from 'react';
import { CourierViewType, ICourier, useCouriersState } from '../../context/couriers';
import { IOrder, OrderStatus } from '@pages/Deliveries/context/orders';
import CourierListItem from '../CourierListItem';
import { useTranslation } from 'react-i18next';

interface IOrderAssignAccordionProps {
  couriers: Dictionary<ICourier>;
  courierItems: Partial<IOrder>;
}

export const OrderAssignAccordion: FC<IOrderAssignAccordionProps> = ({
  couriers,
  courierItems,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const { t } = useTranslation();

  return (
    <div className={classes.orderAssignAccordion}>
      <ul className={`${isMobileScreen ? 'mobile' : null}`}>
        {Object.keys(couriers)
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          .sort((a, b) =>
            couriers[a]?.firstName?.localeCompare(couriers[b]?.firstName)
          )
          .sort((a, _) => {
            if (
              couriers[a].id === courierItems.courier?.id &&
              courierItems.status !== OrderStatus.Unassigned
            ) {
              return -1;
            }
            return 0;
          })
          .map((id) => (
            <div key={id}>
              {(courierItems.status === OrderStatus.Unassigned &&
                !!couriers[id]?.isGuest) ||
              ((courierItems.status === OrderStatus.Assigned ||
                courierItems.status === OrderStatus.AssignedToNextPool) &&
                !!couriers[id]?.isGuest &&
                courierItems.courier?.id !== id) ? (
                <>
                  {Object.keys(couriers).length < 2 &&
                  !!couriers[id]?.isGuest &&
                  !couriers[id]?.orderPool?.route?.waypoints
                    ?.length ? (
                    <Typography
                      variant="body1"
                      className={`body_small_bold ${classes.itemNoData}`}
                    >
                      {t('order.accordion_no_courier')}
                    </Typography>
                  ) : null}
                </>
              ) : (
                <CourierListItem
                  currentOrderStatus={courierItems.status}
                  viewType={CourierViewType.ActionView}
                  key={`${id}_${courierItems.reference}`}
                  orderId={courierItems.reference}
                  assignedCourierId={
                    courierItems.status === OrderStatus.Unassigned
                      ? undefined
                      : courierItems.courier?.id
                  }
                  hash={courierItems.hash}
                  hasAlcohol={courierItems.hasAlcohol}
                  {...couriers[id]}
                />
              )}
            </div>
          ))
          }
      </ul>
    </div>
  );
};

export default OrderAssignAccordion;
